export type AzureInstanceOption = {
  name: string;
  id?: string;
  connectionId?: string;
  region?: string;
  [key: string]: unknown;
};

export type AzureInstanceStepValue = {
  azureAccount: string;
  computerName: string;
  location: string;
  region: string;
  resourceGroup: string;
  vmSize: string;
  network: string;
  subnet: string;
  subnetName: string;
  storage: string;
  container: string;
  bootDiagnosticStorage: string;
  connectionId: string;
  valid: boolean;
};

export const DefaultAzureInstanceStepValue: AzureInstanceStepValue = {
  azureAccount: '',
  computerName: '',
  location: '',
  region: '',
  resourceGroup: '',
  vmSize: '',
  network: '',
  subnet: '',
  subnetName: '',
  storage: '',
  container: '',
  bootDiagnosticStorage: '',
  connectionId: '',
  valid: true
};

export const DisabledBootDiagnostic = { name: 'Disabled', id: 'Disabled' };
